import React, { useState, useEffect } from 'react';
import { DeleteIcon } from '../icons/DeleteIcon';
import './numpad.css';
import Key from './key';
import Money from '../Common/Money/Money';

const truncateString = (value, decimals = 2) =>
  (Math.trunc(parseFloat((value * 100).toFixed(decimals))) / 100).toFixed(decimals);

const truncate = (value, decimals = 2) => parseFloat(truncateString(value, decimals));

export function Numpad({ initialValue, onValueChange, title1, title2, showValue = true }) {
  const [value, setValue] = useState(0);
  const [pristine, setPristine] = useState(true);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    onValueChange && onValueChange(value);
  }, [value]);

  const onNumberClick = (number) => {
    setPristine(false);
    if (pristine) {
      setValue(truncate(number / 100));
      return;
    }
    const newValue = truncate(value * 10 + number / 100);
    if (newValue <= 999999.99) {
      setValue(newValue);
    }
  };

  const onBackspace = () => {
    setPristine(false);
    if (Math.abs(value) < 1e-6) return;
    const newValue = truncate(value * 0.1);
    if (newValue >= 0) {
      setValue(newValue);
    }
  };

  const onClear = () => {
    setPristine(false);
    setValue(0);
  };

  const Icon = () => {
    return <DeleteIcon color={'#fff'} size={'40px'} />;
  };

  return (
    <div className='keypad'>
      {showValue && (
        <div className='keypad-amount-container text-50 line-height-1'>
          <div className='keypad-amount'>
            <Money value={value} />
          </div>
          <div className='keypad-title text-12 text-center line-height-1'>{title1}</div>
        </div>
      )}
      <div className='keyboard-container p-0 col-sm col-md-10 col-lg-8'>
        <p>{title2}</p>
        <div className='keyboard mt-3 justify-content-center'>
          <Key classKey='top-left' onClick={() => onNumberClick(1)} value={1} />
          <Key onClick={() => onNumberClick(2)} value={2} />
          <Key classKey='top-right' onClick={() => onNumberClick(3)} value={3} />
          <Key onClick={() => onNumberClick(4)} value={4} />
          <Key onClick={() => onNumberClick(5)} value={5} />
          <Key onClick={() => onNumberClick(6)} value={6} />
          <Key onClick={() => onNumberClick(7)} value={7} />
          <Key onClick={() => onNumberClick(8)} value={8} />
          <Key onClick={() => onNumberClick(9)} value={9} />
          <Key backspace classKey='bottom-left' onClick={onBackspace} value={Icon} />
          <Key onClick={() => onNumberClick(0)} value={0} />
          <Key clear classKey='bottom-right' onClick={onClear} value={'C'} />
        </div>
      </div>
    </div>
  );
}
